import Layout from "../components/Layout";
import { PhysicalBlotter } from "../components/_Transactions/PhysicalBlotter";

const PhysicalBlotterPage = (props: any) => {
    return (
        <Layout>
            <PhysicalBlotter/>
        </Layout>
    )
}

export default PhysicalBlotterPage